import styled from 'styled-components';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Icon } from '../../../elements/Icon';
import { Portal } from '../../../helpers/Portal';
import { PopoverBase } from '../../../elements/Popover/Base';
import { Checkbox } from '../../../elements/Checkbox';
import { Button } from '../../../elements/Button';
import { useTableContext } from '../_context/TableProvider';
const ColumnSelectorWrapper = styled.div `
  position: relative;
`;
const Dots = styled(Icon.Dots) `
  --icon-color: ${({ theme, $isOpen }) => theme.secondary.blendToBackground($isOpen ? 1000 : 800)};

  padding: 0;
  transition:
    transform 0.2s,
    color 0.2s;

  &:hover {
    --icon-color: ${({ theme }) => theme.secondary.background};
  }

  transform: rotate(${({ $isOpen }) => ($isOpen ? 90 : 0)}deg);
`;
const List = styled.div `
  display: grid;
  grid-gap: 12px;
  align-items: start;
  width: 200px;
  padding: 16px;
`;
const PopoverWrapper = styled(PopoverBase) `
  --popover-padding: 0;
  --popover-width: max-content;
  --popover-right: auto;
  --popover-left: auto;
  --popover-top: auto;

  position: static;
`;
const Title = styled.div `
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.foreground};
  padding: 8px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};
`;
export const ColumnPopover = ({ value, options, onChange, title, ...props }) => {
    const isActive = useCallback((current, currentValue) => current?.includes(currentValue), [options]);
    return (React.createElement(PopoverWrapper, { ...props },
        React.createElement(Title, null, title),
        React.createElement(List, null, options.map((option, index) => (React.createElement(Checkbox, { key: index, isChecked: isActive(value, option.id), onCheckedChange: (checked) => onChange?.(option.id, checked), label: option.label }))))));
};
export const ColumnSelector = ({ onChange, value, title = 'Add Columns' }) => {
    const { columns } = useTableContext();
    const [isHeaderPopoverOpen, setIsHeaderPopoverOpen] = useState(false);
    const [headerPlacement, setHeaderPlacement] = useState('left-start');
    const referenceRef = useRef(null);
    const togglePopover = useCallback(() => {
        setIsHeaderPopoverOpen((prev) => !prev);
    }, []);
    const activeIds = Object.entries(value)
        .filter(([, isVisible]) => Boolean(isVisible))
        .map(([id]) => id);
    const options = useMemo(() => {
        return columns
            .filter((c) => c.id !== undefined && !!c.meta?.headerName)
            .map((c) => ({
            id: c.id,
            label: c.meta.headerName,
        }));
    }, [columns]);
    return (React.createElement(ColumnSelectorWrapper, null,
        React.createElement(Button, { ref: referenceRef, type: "button", size: "small", variant: "subtle", onClick: togglePopover, icon: React.createElement(Dots, { "$isOpen": isHeaderPopoverOpen }) }),
        React.createElement(Portal, { reference: referenceRef, placement: "left-start", onPlacementChange: setHeaderPlacement, offsetCross: headerPlacement === 'left-start' ? -5 : 5, offsetMain: 4, zIndex: 4, shouldCalculate: { is: isHeaderPopoverOpen, timeout: 200 } },
            React.createElement(ColumnPopover, { options: options, value: activeIds, onChange: (id, isVisible) => {
                    onChange?.({ ...value, [id]: isVisible });
                }, show: isHeaderPopoverOpen, title: title, onClose: () => setIsHeaderPopoverOpen(false) }))));
};
//# sourceMappingURL=ColumnSelector.js.map